import type { Components, Theme } from "@mui/material/styles";

import {
  autocompleteOverrides,
  autocompletePopperOverrides,
} from "@app/theme/overrides/autocomplete.ts";
import { alertOverrides } from "@app/theme/overrides/alert.ts";
import { controlOverrides } from "@app/theme/overrides/controls.ts";
import { fieldOverrides } from "@app/theme/overrides/fields.ts";
import { selectOverrides } from "@app/theme/overrides/select.ts";
import { tableOverrides } from "@app/theme/overrides/table.ts";
import { tabsOverrides } from "@app/theme/overrides/tabs.ts";
import { toolbarOverrides } from "@app/theme/overrides/toolbar.ts";
import { typographyOverrides } from "@app/theme/overrides/typography.ts";

/**
 * Component overrides that restore the Digital HIG look on top of the Weave
 * "legacy" theme. Each module is removed when the DHIG component it patches is
 * replaced by a plain MUI one. Modules must not share a component key, since
 * they are combined with a shallow spread.
 */
export const dhigLookOverrides: Components<Omit<Theme, "components">> = {
  ...alertOverrides,
  ...tabsOverrides,
  ...autocompleteOverrides,
  ...autocompletePopperOverrides,
  ...controlOverrides,
  ...fieldOverrides,
  ...tableOverrides,
  ...selectOverrides,
  ...toolbarOverrides,
  ...typographyOverrides,
};
